import _ from "lodash";
import React, { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { gateType } from "./gate";
import { XMarkIcon } from "@heroicons/react/20/solid";


function useGates() {
    const [gates, setGates] = useState<{ key: number, items: gateType[] }[]>([])
    const [newLine, setNewLine] = useState<number | null>(null)
    const [newGate, setNewGate] = useState<gateType | null>(null)



    var addNewGate = (newGate: gateType, newLine: number) => {
        setNewGate(newGate)
        setNewLine(newLine)
    }


    let deleteGate = (index: number, line: number) => {
        var newItems = gates
        if (newItems && !_.isEmpty(newItems.filter(i => i.key == line))) {
            var selectedLine = newItems.filter(i => i.key == line)[0]
            var item = selectedLine.items[index]
            newItems = [...newItems.filter(i => i.key != line),
            {
                key: line, items:
                    selectedLine.items.length - 1 == index ?
                        [...selectedLine.items.slice(0, index)]
                        :
                        [...selectedLine.items.map((g, ind) => index != ind ? g : { id: 13, type: 4, color: "", child: <span></span>, name: "" })]
            }]

            if (item.type == 1 || item.type == 2) {
                var secondLine = newItems.filter(i => i.key == line - 1)[0]
                newItems = [...newItems.filter(i => i.key != line - 1),
                {
                    key: line - 1,
                    items: secondLine.items.length - 1 == index ?
                        [...secondLine.items.filter((g, ind) => index != ind)]
                        :
                        [...secondLine.items.map((g, ind) => index != ind ? g : { id: 13, type: 4, color: "", child: <span></span>, name: "" })]
                }]
            }
            if (item.type == 2) {
                var thridLine = newItems.filter(i => i.key == line - 2)[0]
                newItems = [...newItems.filter(i => i.key != line - 2),
                {
                    key: line - 2,
                    items: thridLine.items.length - 1 == index ?
                        [...thridLine.items.filter((g, ind) => index != ind)]
                        :
                        [...thridLine.items.map((g, ind) => index != ind ? g : { id: 13, type: 4, color: "", child: <span></span>, name: "" })]
                }]
            }
            setGates(newItems)
        }
    }



    useEffect(() => {
        if (newLine == null || !newGate)
            return
        var newItems = gates
        var line = newLine;
        var item = newGate;
        var selectedLine =
            newItems && !_.isEmpty(newItems.filter(i => i.key == line)) ?
                newItems.filter(i => i.key == line)[0]
                : { key: line, items: [] }
        if (item.type == 0) {
            newItems = [...newItems.filter(i => i.key != line),
            {
                key: line, items: [...selectedLine.items, item]
            }]
        } else if (item.type == 1) {
            var secondLine =
                newItems && !_.isEmpty(newItems.filter(i => i.key == line - 1)) ?
                    newItems.filter(i => i.key == line - 1)[0] :
                    { key: line - 1, items: [] }
            if (secondLine.items.length < selectedLine.items.length) {
                selectedLine.items.forEach((e, index) => {
                    if (index >= secondLine.items.length) {
                        secondLine = { ...secondLine, items: [...secondLine.items, { id: 13, type: 4, color: "", child: <span></span>, name: "" }] }
                    }
                });
            } else if (secondLine.items.length > selectedLine.items.length) {
                secondLine.items.forEach((e, index) => {
                    if (index >= selectedLine.items.length) {
                        selectedLine = { ...selectedLine, items: [...selectedLine.items, { id: 13, type: 4, color: "", child: <span></span>, name: "" }] }
                    }
                });
            }

            newItems = [...newItems.filter(i => i.key != line && i.key != line - 1),
            {
                key: line, items: [...selectedLine.items,
                item.name != "swap" ? item :
                    {
                        ...item, color: '', child:
                            <div className="relative contents">
                                <div style={{ marginTop: '-30px' }} className='grid h-[30px] grid-cols-2'><span className='border-l'></span><span className='border-r'></span></div>
                                <XMarkIcon className="w-6 h-6 absolute" />
                            </div>
                    }
                ]
            },
            {
                key: line - 1, items: [...secondLine.items,
                item.name == "swap" ?
                    {
                        id: 4, type: 3, color: "", child:
                            <div className="relative contents">
                                <div style={{ marginTop: '30px' }} className='grid h-[30px] grid-cols-2'><span className='border-l'></span><span className='border-r'></span></div>
                                <XMarkIcon className="w-6 h-6 absolute" />
                            </div>
                        , name: ""
                    }
                    :
                    { id: 4, type: 3, color: "", child: <div style={{ marginTop: '30px' }} className='grid h-[30px] grid-cols-2'><span className='border-l'></span><span className='border-r'></span></div>, name: "" }
                ]
            }
            ]

        } else if (item.type == 2) {
            var secondLine = newItems && !_.isEmpty(newItems.filter(i => i.key == line - 1)) ?
                newItems.filter(i => i.key == line - 1)[0] :
                { key: line - 1, items: [] }

            var thridLine = newItems && !_.isEmpty(newItems.filter(i => i.key == line - 2)) ?
                newItems.filter(i => i.key == line - 2)[0] :
                { key: line - 2, items: [] }
            var maxLength = _.max([selectedLine.items.length, secondLine.items.length, thridLine.items.length]) as number

            if (selectedLine.items.length < maxLength) {
                var items = selectedLine.items
                _.range(maxLength - selectedLine.items.length).forEach(e =>
                    items.push(
                        { id: 13, type: 4, color: "", child: <span></span>, name: "" }
                    )
                )
                selectedLine = { ...secondLine, items: items }
            }
            if (secondLine.items.length < maxLength) {
                var items = secondLine.items
                _.range(maxLength - secondLine.items.length).forEach(e =>
                    items.push(
                        { id: 13, type: 4, color: "", child: <span></span>, name: "" }
                    )
                )
                secondLine = { ...secondLine, items: items }
            } if (thridLine.items.length < maxLength) {
                var items = thridLine.items
                _.range(maxLength - thridLine.items.length).forEach(e =>
                    items.push(
                        { id: 13, type: 4, color: "", child: <span></span>, name: "" }
                    )
                )
                thridLine = { ...thridLine, items: items }
            }
            newItems = [...newItems.filter(i => i.key != line && i.key != line - 1 && i.key != line - 2),
            {
                key: line, items: [...selectedLine.items, item]
            },
            {
                key: line - 1, items: [...secondLine.items,
                { id: 4, type: 3, color: "", child: <div style={{ marginTop: '30px' }} className='grid h-[30px] grid-cols-2'><span className='border-l'></span><span className='border-r'></span></div>, name: "" },
                ]
            },
            {
                key: line - 2, items: [...thridLine.items,
                { id: 4, type: 3, color: "", child: <div style={{ marginTop: '50px' }} className='grid h-[50px] grid-cols-2'><span className='border-l'></span><span className='border-r'></span></div>, name: "" },
                ]
            }]
        }
        setGates(newItems);
        setNewGate(null);
        setNewLine(null);

    }, [newLine, newGate])

    let updateGate = (index: number, line: number, ratio: string) => {
        setGates([...gates.filter(i => i.key != line),
        {
            key: line,
            items: gates.filter(i => i.key == line)[0].items.map((i, idx) => idx == index ? { ...i, ratio: ratio } : i)
        }]
        )
    }

    useEffect(() => {
        console.log('gates', gates)
    }, [gates])
    return { gates, updateGate, addNewGate, deleteGate }
}

let Gates = createContainer(useGates);
export default Gates;
